import {axios as http} from "@/plugins/http"

export default class Api {
    static themes() {
        return http.post('/api/v1/catalog/themes')
    }
}
